import React from 'react'
import { Avatar } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'

import type { ActiveDomainSelectorProps } from '../types'

// NOTE: ActiveDomainSelector is imported as a named export from ../index.
import { ActiveDomainSelector } from '../index'

// ============================================================================
// Error Boundary
// ============================================================================

interface ErrorBoundaryState {
    hasError: boolean
}

/**
 * ActiveDomainSelectorErrorBoundary - Error boundary for the domain selector
 *
 * Catches rendering errors within ActiveDomainSelector and displays a
 * fallback UI instead of crashing the entire sidebar/application.
 *
 * Requirements: 11.10
 */
class ActiveDomainSelectorErrorBoundary extends React.Component<ActiveDomainSelectorProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.error('[ActiveDomainSelector] Rendering error caught by error boundary:', error)
        console.error('[ActiveDomainSelector] Component stack:', errorInfo.componentStack)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="active-domain-select-item active-domain-select-item-selected">
                    <div className="domain-item-content">
                        <div className="domain-avatar">
                            <Avatar icon={<GlobalOutlined />} gap={2} />
                        </div>
                        <div className="domain-info">
                            <div className="domain-title">Domain Selector</div>
                            <div className="domain-description">Unable to load</div>
                        </div>
                    </div>
                </div>
            )
        }

        return <ActiveDomainSelector {...this.props} />
    }
}

export default ActiveDomainSelectorErrorBoundary
